import { render, staticRenderFns } from "./EditProductPopup.vue?vue&type=template&id=4cda16f6&scoped=true"
import script from "./EditProductPopup.vue?vue&type=script&lang=js"
export * from "./EditProductPopup.vue?vue&type=script&lang=js"
import style0 from "./EditProductPopup.vue?vue&type=style&index=0&id=4cda16f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cda16f6",
  null
  
)

export default component.exports